import React from 'react';
import styles from "../../styles/metaai/MetaLocation.module.css";

const DEFAULT_ADDRESS = "서울 강서구 공항대로 237, 1207호(마곡동, 에이스타워마곡)";

const MetaLocation = ({ address = DEFAULT_ADDRESS, }) => {
  const mapSrc = "https://www.google.com/maps?q=" + encodeURIComponent(address) + "&hl=ko&z=16&output=embed";
  
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>오시는 길</h2>
        <p className={styles.sub}>지도로 위치를 확인하고, 대중교통 안내를 참고하세요.</p>

        <div className={styles.mapWrap}>
          <iframe
            title="MetaAI 위치 지도"
            src={mapSrc}
            className={styles.map}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className={styles.table}>
          <div className={styles.row}>
            <div className={styles.label}>주소</div>
            <div className={styles.value}>
              {address}
              <a
                className={styles.link}
                href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(address)}
                target="_blank"
                rel="noreferrer"
              >
                길찾기
              </a>
            </div>
          </div>

          <div className={styles.row}>
            <div className={styles.label}>대중교통</div>
            <div className={styles.value}>
              <div className={styles.transitText}>
                지하철 : 5호선 발산역 9번 출구에서 도보 5분 거리
              </div>
              <div className={styles.transitText}>
                버스 : 마곡동로사거리(중) 정류장에서 하차 후 도보 3분 거리
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MetaLocation